import type { ITemplateAssignedType } from '~/types/template';
import type { IListTabProps } from '~/presentation/common';
import type { ChoiceListProps } from '@shopify/polaris';

import { EMPTY_PRODUCT, EMPTY_TEMPLATE, TEMPLATE_NO_THUMB } from './thumbnail';
import { TemplateType, ProviderSource } from '~/types/template';

export const GEMX_TEMPLATE_PREFIX = 'gx';
export const PREFIX_DUPLICATE_NAME = 'Copy of';

/**
 * Prefix GemPages' scheduled-publish job stamps onto the transient Shopify template files it
 * uploads (key shape: `templates/{pageType}.gp-sched-{scheduleID}-{themePageID}.json`). These are
 * internal staging files, not user-pickable templates, so the picker hides them.
 */
export const SCHEDULED_TEMPLATE_PREFIX = 'gp-sched';

export const TEMPLATE_NAME_MAP: Record<TemplateType, string> = {
  [TemplateType.HOME]: 'Home',
  [TemplateType.PAGE]: 'Landing',
  [TemplateType.ARTICLE]: 'Blog',
  [TemplateType.COLLECTION]: 'Collection',
  [TemplateType.COLLECTION_LIST]: 'Collections',
  [TemplateType.PRODUCT]: 'Product',
  [TemplateType.CART]: 'Cart',
  [TemplateType.SEARCH]: 'Search',
  [TemplateType.NOT_FOUND]: '404',
  [TemplateType.BLOG]: 'Blog',
  [TemplateType.PASSWORD]: 'Password',
  [TemplateType.GIF_CART]: 'GIF Cart',
  [TemplateType.CONTACT]: 'Contact',
  [TemplateType.ALL]: 'All',
  [TemplateType.ACCOUNT]: 'Account',
  [TemplateType.CHECKOUT]: 'Checkout',
  [TemplateType.GIFT_CARD]: 'Gift Card',
};

export const TAB_TEMPLATES: IListTabProps<TemplateType>[] = [
  {
    key: TemplateType.HOME,
    name: 'Home',
  },
  {
    key: TemplateType.PAGE,
    name: 'Landing',
  },
  {
    key: TemplateType.PRODUCT,
    name: 'Product',
  },
  {
    key: TemplateType.COLLECTION,
    name: 'Collection',
  },
  {
    key: TemplateType.ARTICLE,
    name: 'Blog post',
  },
];

export const FILTER_TAB_TEMPLATES: ChoiceListProps['choices'] = [
  {
    value: TemplateType.PAGE,
    label: 'Landing page',
  },
  {
    value: TemplateType.HOME,
    label: 'Home page',
  },
  {
    value: TemplateType.PRODUCT,
    label: 'Product page',
  },
  {
    value: TemplateType.COLLECTION,
    label: 'Collection page',
  },
  {
    value: TemplateType.ARTICLE,
    label: 'Blog post',
  },
];

export const TEMPLATE_ASSIGNED: ITemplateAssignedType[] = [
  TemplateType.COLLECTION,
  TemplateType.PRODUCT,
  TemplateType.ARTICLE,
  TemplateType.PAGE,
  TemplateType.HOME,
];

export const TEMPLATE_ORIGIN: TemplateType[] = [
  TemplateType.COLLECTION,
  TemplateType.PRODUCT,
  TemplateType.HOME,
  TemplateType.ARTICLE,
  TemplateType.PAGE,
  TemplateType.CART,
  TemplateType.SEARCH,
  TemplateType.NOT_FOUND,
  TemplateType.BLOG,
  TemplateType.PASSWORD,
  TemplateType.GIF_CART,
];

export const TEMPLATE_IMAGE = {
  EMPTY_TEMPLATE,
  EMPTY_PRODUCT,
  DEFAULT: TEMPLATE_NO_THUMB,
};

export const TEMPLATE_SHOPIFY: ProviderSource[] = [
  ProviderSource.SHOPIFY,
  ProviderSource.SHOPIFY_GEMX,
  ProviderSource.SHOPIFY_ORIGIN,
];

export const PROVIDER_SHOPIFY_DUPLICATE: ProviderSource[] = [
  ...TEMPLATE_SHOPIFY,
  ProviderSource.SHOPIFY_GP_BACKUP,
];

export const PROVIDER_GEMPAGES_DUPLICATE: ProviderSource[] = [
  // ProviderSource.GEMPAGESV6,
  ProviderSource.GEMPAGESV7,
];

export const PROVIDER_SOURCE_GEMPAGES = [ProviderSource.GEMPAGESV6, ProviderSource.GEMPAGESV7];

export const ASSET_TYPE_SHOPIFY = [
  ProviderSource.SHOPIFY,
  ProviderSource.SHOPIFY_GP_BACKUP,
  ProviderSource.SHOPIFY_GEMX,
  ProviderSource.SHOPIFY_PAGE_FLY,
  ProviderSource.SHOPIFY_FOXIFY,
  ProviderSource.SHOPIFY_ECOMPOSER,
];

export const PROVIDER_SOURCE_SORT: ProviderSource[] = [
  ProviderSource.SHOPIFY_ORIGIN,
  ProviderSource.GEMPAGESV7,
  ProviderSource.GEMPAGESV6,
  ProviderSource.SHOPIFY_GEMX,
  ProviderSource.SHOPIFY,
  ProviderSource.SHOPIFY_FOXIFY,
  ProviderSource.SHOPIFY_ECOMPOSER,
  ProviderSource.SHOPIFY_PAGE_FLY,
  ProviderSource.SHOPIFY_SHOGUN,
];
